module.exports = __webpack_public_path__ + "static/media/abzug_start.f3a2d106.jpg";